<ng-template #topCardsGmaAlarm>
  @let gmaAlarmsValue = gmaAlarms();
  @if (gmaAlarmsValue.length > 0) {
    <mat-card
      appearance="outlined"
      [tp]="info"
      variation="popper"
      trigger="mouseenter"
      tpPlacement="bottom"
      [tpIsLazy]="true"
      (click)="onNavigateToSmwPage()">
      <p>GMA-Alarme</p>
      <h1
        [ngStyle]="{
          color: smwService.gmaAlarmColors[alarmOrder[worsestAlarm()]],
        }">
        <fa-icon [icon]="['far', 'road']"></fa-icon>
        &nbsp; {{ gmaAlarmsValue.length }}
      </h1>

      <ng-template #info>
        <table>
          @for (gmaAlarm of gmaAlarmsValue; track $index) {
            <tr>
              <td>
                <div
                  class="alarm"
                  [ngStyle]="{
                    borderColor:
                      'transparent transparent ' +
                      smwService.gmaAlarmColors[gmaAlarm.value] +
                      ' transparent',
                  }">
                  <p>{{ gmaAlarm.value }}</p>
                </div>
              </td>
              <td>{{ gmaAlarm.name }}</td>
              <td>
                <b>{{
                  'PRODUCT.SMW.Alarm.' + smwService.gmaAlarmText[gmaAlarm.value]
                    | translate
                }}</b>
              </td>
            </tr>
          }
        </table>
      </ng-template>
    </mat-card>
  }
</ng-template>
